<template>
  <BaseSection :is-main-heading="true" heading="TKD Serviceleistungen">
    <BaseSection>
      <div class="md:flex md:gap-4">
        <BaseDropdown
          v-model:selection="deviceService.reason"
          label="Grund auswählen"
          dropdown-text="Grund auswählen"
          :options-list="noTKDPossibleReasons"
          :validation="v$.deviceService.reason"
          class="md:basis-3/4"
          @update:selection="() => (deviceService.note = undefined)"
        />
        <DateMount
          class="md:basis-1/4"
          :device-event="recordingDate"
          label="Servicedatum"
          test-id="recordingDate"
        />
      </div>

      <BaseTextarea
        v-model:input-text="deviceService.note"
        label="Bemerkung"
        test-id="repair_note"
        :validation="v$.deviceService.note"
      />
    </BaseSection>
  </BaseSection>
</template>
<script setup lang="ts">
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import BaseDropdown from '@/components/UI/Dropdown/BaseDropdown.vue';
import DateMount from '@/components/Forms/DeviceFormComponents/DateMount.vue';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import BaseTextarea from '@/components/UI/Note/BaseTextarea.vue';
import Checkbox from '@/components/UI/Checkbox/Checkbox.vue';
import BaseFormInput from '@/components/UI/Input/BaseFormInput.vue';
import MeasurementUnit from '@/components/Forms/DeviceFormComponents/MeasurementUnit.vue';
import {
  AccessoryType,
  adapterDemountReasonList,
  AdapterServiceTypeEnum,
  DeviceServiceReasonEnum,
  noTKDPossibleReasons,
  DeviceServiceTypeEnum,
  deviceServiceList,
  noTKDPossibleServiceList,
} from '@/enums/device';
import { InstallationPoint } from '@/models/installationPoint/InstallationPoint';

import { useValidation } from '@/composables/useValidation';
import { Device } from '@/models/devices/Device';
import { BatteryPack } from '@/models/installationPoint/Accessory';
import { DeviceService } from '@/models/installationPoint/DeviceService';
import { AccessoryService } from '@/models/installationPoint/AccessoryService';

const deviceService = defineModel<DeviceService>('deviceService');

const { v$, isFormValid } = useValidation({
  deviceService,
});

const emit = defineEmits(['update:modelValue']);

onMounted(() => {
  if (deviceService.value) {
    deviceService.value.type = DeviceServiceTypeEnum.NO_SERVICE_POSSIBLE;
  }
});

const recordingDate = computed(() => {
  return {
    timestamp: new Date().toISOString(),
  };
});

const isLocalFormValid = computed(() => {
  return isFormValid.value;
});

watch(isLocalFormValid, (val) => {
  emit('update:modelValue', val);
});
</script>
